export default __webpack_public_path__ + "static/media/photo--lg--1.1a17ee82.jpg";